module.exports = __webpack_public_path__ + "img/game-board-simple.fec251ce.svg";